import * as Styles from './styles'

const formatBRL = (value?: number) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(value) || 0)

interface OrderAmountsProps {
  amount?: number
  discount?: number
  shipping?: number
  noImportCost?: boolean
  nationalFreight?: number
}
export default function OrderAmounts({
  amount = 0,
  discount = 0,
  shipping = 0,
  noImportCost = false,
  nationalFreight = 0
}: OrderAmountsProps) {
  const subtotal = noImportCost ? amount - nationalFreight : amount - shipping
  return (
    <Styles.OrderAmountsContainer>
      <Styles.PackageAmount isTotal={false}>
        <span>Subtotal</span>
        <span>{formatBRL(subtotal)}</span>
      </Styles.PackageAmount>
      {!noImportCost && (
        <Styles.PackageAmount isTotal={false}>
          <span>Custo de importação</span>
          <span>{formatBRL(shipping)}</span>
        </Styles.PackageAmount>
      )}
      {nationalFreight > 0 && (
        <Styles.PackageAmount isTotal={false}>
          <span>Frete nacional</span>
          <span>{formatBRL(nationalFreight)}</span>
        </Styles.PackageAmount>
      )}
      <Styles.PackageAmount isTotal={false}>
        <span>Descontos</span>
        <span>- {formatBRL(discount)}</span>
      </Styles.PackageAmount>
      <Styles.PackageAmount isTotal>
        <span>Total</span>
        <span>{formatBRL(amount)}</span>
      </Styles.PackageAmount>
    </Styles.OrderAmountsContainer>
  )
}
